import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { offeringsDraftsRoute } from '..';

export const offeringsDraftUploadRoute = createRoute({
  getParentRoute: () => offeringsDraftsRoute,
  path: 'upload',
  component: lazyRouteComponent(() => import('./OfferingsDraftUploadView')),
});
